<template>
    <div>
        <div class="b_clear_banner">
            <hero-banner-assets :image="heroImage" />

            <div class="container">
                <back-button v-if="!$device.isDesktop" :items="breadcrumbs" />

                <div class="banner_content">
                    <div class="banner_content_inner w100">
                        <div class="content">
                            <breadcrumbs
                                v-if="$device.isDesktop"
                                :items="breadcrumbs"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="b_event">
            <div class="page_decor page_decor_right">
                <div class="image_decor">
                    <picture v-full-image-path:assets="'decor_event_01.svg'" />
                </div>
            </div>
            <div class="page_decor page_decor_left">
                <div class="image_decor">
                    <picture v-full-image-path:assets="'decor_event_02.svg'" />
                </div>
            </div>

            <div class="container">
                <div class="page_title">
                    <h1>{{ pageTitle }}</h1>
                </div>

                <div class="news_filter">
                    <div class="filter_wrapper flex justify_between">
                        <div class="filter">
                            <div class="filter_form flex">
                                <div class="form_row">
                                    <div>
                                        <label class="form_label">
                                            {{ $t('articlesCommon.fromDate') }}
                                        </label>
                                    </div>

                                    <datepicker
                                        v-model="selectedFromDate"
                                        :max-date="
                                            selectedToDate
                                                ? new Date(selectedToDate)
                                                : null
                                        "
                                    />
                                </div>
                                <div class="form_row">
                                    <div>
                                        <label class="form_label">
                                            {{ $t('articlesCommon.toDate') }}
                                        </label>
                                    </div>

                                    <datepicker
                                        v-model="selectedToDate"
                                        :min-date="
                                            selectedFromDate
                                                ? new Date(selectedFromDate)
                                                : null
                                        "
                                    />
                                </div>
                                <div class="form_row">
                                    <button
                                        class="btn_filtering"
                                        type="button"
                                        @click.prevent="onSearchClick"
                                    >
                                        {{ $t('articlesCommon.dateFilter') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="search_wrapper">
                            <div class="search_form relative">
                                <input
                                    v-model="params.search"
                                    class="form_control"
                                    type="text"
                                    :placeholder="
                                        $t('articlesCommon.searchPlaceholder')
                                    "
                                />
                                <button
                                    class="btn_reset btn_search"
                                    type="button"
                                    @click.prevent="onSearchClick"
                                >
                                    {{ $t('articlesCommon.search') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="news_section">
                    <div class="news_list flex justify_between">
                        <event-item
                            v-for="event in events"
                            :key="event.id"
                            :event="event"
                        />
                    </div>
                </div>

                <pagination
                    v-if="events.length"
                    :current-page="params.currentPage"
                    :page-count="pageCount"
                    :is-mobile="$device.isMobile"
                    @next-page="fetchPage('next')"
                    @previous-page="fetchPage('previous')"
                    @load-page="fetchPage"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import headMixin from '@/mixins/head.mixin.js';
import Datepicker from '@/components/Datepicker';
import EventItem from '@/components/events/SingleItem';
import Pagination from '@/components/events/Pagination';
import BackButton from '@/components/elements/BackButton';
import Breadcrumbs from '@/components/elements/Breadcrumbs';
import HeroBannerAssets from '@/components/elements/HeroBannerAssets';

export default {
    components: {
        EventItem,
        BackButton,
        Datepicker,
        Pagination,
        Breadcrumbs,
        HeroBannerAssets
    },

    mixins: [headMixin],

    data() {
        const {
            page: currentPage = 1,
            fromDate = '',
            toDate = '',
            q = ''
        } = this.$route.query;

        return {
            params: {
                currentPage: parseInt(currentPage),
                perPage: 16,
                total: 0,
                search: q,
                fromDate,
                toDate,
                type: null
            },
            hero: {
                image: 'hero_image_events.jpg',
                mobileImage: 'hero_image_events_mobile.jpg'
            },
            articles: [],
            selectedFromDate: fromDate,
            selectedToDate: toDate,
            timer: null
        };
    },

    computed: {
        headTitle() {
            return this.pageTitle;
        },

        pageCount() {
            const { perPage, total } = this.params;

            return Math.ceil(total / perPage);
        },

        heroImage() {
            return this.$device.isDesktop
                ? this.hero.image
                : this.hero.mobileImage;
        }
    },

    methods: {
        ...mapActions({
            fetchEvents: 'events/index'
        }),

        isToDateAvailable(date) {
            if (!this.selectedFromDate) {
                return false;
            }

            return this.$dayjs(date).isBefore(this.selectedFromDate);
        },

        isFromDateAvailable(date) {
            if (!this.selectedToDate) {
                return false;
            }

            return this.$dayjs(date).isAfter(this.selectedToDate);
        },

        async fetchItems() {
            this.updateUrl();

            try {
                const { rows, count } = await this.fetchEvents(this.params);

                this.events = rows;
                this.params.total = count;
            } catch (error) {
                console.error(error);
            }
        },

        async fetchPage(value) {
            if (Number.isInteger(value)) {
                this.params.currentPage = value;
            } else {
                value === 'next'
                    ? this.params.currentPage++
                    : this.params.currentPage--;
            }

            await this.fetchItems();
        },

        onSearchClick() {
            this.params.fromDate = this.selectedFromDate;
            this.params.toDate = this.selectedToDate;
            this.params.currentPage = 1;

            this.fetchItems();
        },

        updateUrl() {
            const { currentPage: page, fromDate, toDate, search } = this.params;

            this.$router.push({
                query: { page, fromDate, toDate, q: search }
            });
        }
    }
};
</script>
